import React, { Fragment, useEffect, useRef, useState } from "react";
import * as userService from "../utils/userService";
import * as httpService from "../services/httpService";
import { Employee_Api_EndPoints } from "../global/end-points";
import LoadingSpinner from "../components/common/loadingSpinner";
import PrivilegeService from "../services/PrivilegeService";
import NoDoughCardMessage from "../components/common/nodoughcard_message";



function VirtualCardComponent() {
    const [isLoad, setIsLoad] = useState(false);
    const [errorFound, setErrorFound] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [cardInfo, setCardInfo] = useState({});
    const didMount = useRef(false);

    // Privilege check states
    const [privilegesChecked, setPrivilegesChecked] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        // Get privileges from sessionStorage, do not call API again
        const privilegesObj = JSON.parse(sessionStorage.getItem("Privileges") || "{}");
        const hasAccess = PrivilegeService.hasReadAccess(privilegesObj, "VirtualCard");
        if (!hasAccess) {
            setErrorFound(true);
            setErrorMessage("You do not have permission to view this page.");
            setIsError(true);
            setPrivilegesChecked(true);
        } else {
            setPrivilegesChecked(true);
            if (!didMount.current) {
                getVirtualCardToken();
            }
        }
        return () => {
            didMount.current = true;
        };
    }, []);

    const getVirtualCardToken = () => {
        if (sessionStorage.UserId != undefined) {
            const body = {
                UserId: Number(sessionStorage.UserId),
            };
            httpService.Get(Employee_Api_EndPoints.GET_VIRTUAL_CARD_TOKEN, body)
                .then((resp) => {
                    let errorFound = false;
                    let errorMessage = '';
                    if (resp.data.errorFound === true &&
                        (resp.data.errorCode === "USER_NOT_FOUND" || resp.data.errorCode === "USER_ADDRESS_NOT_FOUND"
                            || resp.data.errorCode === "PRODUCTID_NOT_FOUND" || resp.data.errorCode === "REQUEST_NOT_ACCEPTED"
                            || resp.data.errorCode === "REQUEST_FAILED")) {

                        errorFound = resp.data.errorFound;
                        errorMessage = 'We have encourted technical issue and virtual card can not be generated. Please try again later';

                    } else if (resp.data.errorFound === false) {
                        errorFound = resp.data.errorFound;
                        errorMessage = '';
                        setCardInfo(resp.data);
                    }

                    setErrorFound(errorFound);
                    setErrorMessage(errorMessage);
                    setIsLoad(true);
                }, () => {
                    setErrorFound(true);
                    setErrorMessage("Technical error occurred.");
                    setIsLoad(true);
                })
        } else {
            userService.ClearSession();
        }
    }

    if (!privilegesChecked) return <LoadingSpinner />;
    if (isError) {
        return (
            <NoDoughCardMessage
                title="Access Denied"
                message={errorMessage}
                onClose={() => setIsError(false)}
            />
        );
    }

    return (
        <Fragment>
            {isLoad &&
                <Fragment>
                    {!errorFound &&
                        <h2 className="text-center color-white">
                            Please click the <a href={cardInfo.url} target="_blank" rel="noopener noreferrer"><h2> link </h2></a> to access the virtual card.
                        </h2>
                    }
                    {errorFound &&
                        <div className="paydata-home switched-content">
                            <h2 className="text-center color-white">{errorMessage}</h2>
                        </div>
                    }
                </Fragment>
            }
            {!isLoad && <LoadingSpinner />}
        </Fragment>
    )
}
export default VirtualCardComponent;